export default __webpack_public_path__ + "static/media/hd7.3630605e.webp";